import { Injectable } from '@angular/core';
import {
    Position,
    PositionClassification,
} from 'src/app/models/position.model';
import { regex } from 'src/config/regex-config';

/**
 * UtilsService
 * will have all the utilities to be used accross the app
 */
@Injectable()
export class UtilsService {
    /**
     * constructor
     */
    public constructor () {}

    /**
     * returns the position classification (isHardware, isAccessories, isEsim, isSim)
     * @param position
     */
    public classifyPosition (position: Position) {
        const simArticleNumberRegex = new RegExp(regex.simArticleNumber);
        const hardwareArticleNumberRegex = new RegExp(
            regex.hardwareArticleNumber,
        );
        const articleNumber = position.articleNumber;
        if (articleNumber) {
            if (simArticleNumberRegex.test(articleNumber)) {
                return PositionClassification.isSim;
            } else if (hardwareArticleNumberRegex.test(articleNumber)) {
                return PositionClassification.isHardware;
            } else {
                return PositionClassification.isAccessories;
            }
        } else {
            return PositionClassification.isEsim;
        }
    }

/**
 * Returns a formatted date and time string and its components.
 * If a date string is provided, it formats that date; otherwise, it uses the current date.
 * @param {string} [dateString] - Optional date string in 'YYYY-MM-DD' format.
 * @return {{ date: string, time: string }}
 */
 public getFormattedDate (dateString?: string) {
    const currentDate = dateString ? new Date(dateString) : new Date();
    const day = currentDate.getDate().toString().padStart(2, '0');
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const year = currentDate.getFullYear().toString();
    const hours = currentDate.getHours().toString().padStart(2, '0');
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const currentDateString = `${day}.${month}.${year}`;
    const currentTimeString = `${hours}:${minutes}`;

    return { date: currentDateString, time: currentTimeString };
}

}
